import $ from "jquery";
import 'owl.carousel';
import 'magnific-popup'

$(document).ready(function () {

  $('.certificate-block__slide').magnificPopup({
    type: 'image',
    mainClass: 'mfp-with-zoom',
    gallery:{
      enabled:true
    },

    zoom: {
      enabled: true,
      duration: 300,
      easing: 'ease-in-out',
    }

  });

  $('.js-gallery-item').magnificPopup({
    type: 'image',
    mainClass: 'mfp-with-zoom',
    gallery:{
      enabled:true
    },

    zoom: {
      enabled: true,
      duration: 300,
      easing: 'ease-in-out',
    }

  });

  $('.gallery-item').magnificPopup({
    type: 'image',
    mainClass: 'mfp-with-zoom',
    gallery:{
      enabled:true
    },

    zoom: {
      enabled: true,
      duration: 300,
      easing: 'ease-in-out',
    }

  });

  $('.diasport-gallery__slide a').magnificPopup({
    type: 'image',
    mainClass: 'mfp-with-zoom',
    gallery:{
      enabled:true
    },

    zoom: {
      enabled: true,
      duration: 300,
      easing: 'ease-in-out',
    }

  });


  $('.js-owl-carousel-diasport').owlCarousel({
    smartSpeed: 500,
    items: 1,
    singleItem: true,
    responsiveClass: true,
    nav: true
  });

  $('.js-owl-carousel-certificates').owlCarousel({
    smartSpeed: 500,
    items: 2,
    singleItem: true,
    responsiveClass: true,
    nav: true,
    margin:10,
    responsive : {
      480: {
        items: 3
      },
      1025: {
        items: 5
      },
      1280: {
        items: 6
      }
    }
  });

  $('.js-owl-carousel-videos').owlCarousel({
    smartSpeed: 500,
    items: 1,
    singleItem: true,
    responsiveClass: true,
    nav: true,
    margin:10,
    responsive : {
      480: {
        items: 2
      },
      1024: {
        items: 3
      }
    }
  });

  $('.js-owl-carousel-events').owlCarousel({
    smartSpeed: 500,
    items: 1,
    singleItem: true,
    responsiveClass: true,
    nav: true
  });

  $('.js-owl-carousel-undertop').owlCarousel({
    smartSpeed: 500,
    items: 2,
    singleItem: true,
    responsiveClass: true,
    nav: true,
    margin:10,
    responsive : {
      640: {
        items: 3,
      },
      1025: {
        items: 5,
      }
    }
  });

  $('.open-popup-link').magnificPopup({
    type:'inline',
    midClick: true,
    removalDelay: 300,
    mainClass: 'mfp-fade'
  });

  $('.open-ccc').magnificPopup({
    type:'inline',
    midClick: true,
    removalDelay: 300,
    mainClass: 'mfp-fade'
  });

  function  toggleMenu () {
    $('.js-open-menu').on('click', () => {
      $('.mobile-menu').slideDown(350);
    });

    $('.js-close-menu').on('click', () => {
      $('.mobile-menu').slideUp(350);
    });

    $('.js-acnhor-item').on('click', () => {
      $('.mobile-menu').slideUp(350);
    });
  }

  toggleMenu();

  function fixedHeader () {
    let scroll = $(window).scrollTop();
    let width = $(window).width();

    if (scroll >= 100) {
      $('.header').addClass('fixed');
    } else {
      $('.header').removeClass('fixed');
    }

    if (scroll >= 300) {
      $('.header').addClass('show');
    } else {
      $('.header').removeClass('show');
    }
  }

  fixedHeader();

  $(window).scroll(function() {
    fixedHeader();
  });

  $(".js-acnhor-item").click(function() {
    $("html, body").animate({
      scrollTop: $($(this).attr("href")).offset().top + "px"
    }, {
      duration: 500,
      easing: "swing"
    });
    return false;
  });

});
